// store/reducers/interviewReducer.js
import {
  GET_SCHEDULED_REQUEST,
  GET_SCHEDULED_SUCCESS,
  GET_SCHEDULED_FAILURE,
  CLEAR_SCHEDULED_ERROR,
  RESET_SCHEDULED,
  FILTER_BY_ROUNDS,
  GET_SHORTLISTED_REQUEST,
  GET_SHORTLISTED_SUCCESS,
  GET_SHORTLISTED_FAILURE
} from './interviewAction'

const initialState = {
  scheduled: {
    data: [],
    filteredData: [],
    loading: false,
    error: null
  },
  shortListed: {
    data: [],
    loading: false,
    error: null
  },
}

const interviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCHEDULED_REQUEST:
      return {
        ...state,
        scheduled: {
          ...state.scheduled,
          loading: true,
          error: null
        }
      }

    case GET_SCHEDULED_SUCCESS:
      return {
        ...state,
        scheduled: {
          ...state.scheduled,
          data: action.payload,
          loading: false,
          error: null
        }
      }

    case GET_SCHEDULED_FAILURE:
      return {
        ...state,
        scheduled: {
          ...state.scheduled,
          loading: false,
          error: action.payload
        }
      }

    case CLEAR_SCHEDULED_ERROR:
      return {
        ...state,
        scheduled: {
          ...state.scheduled,
          error: null
        }
      }

    case RESET_SCHEDULED:
      return {
        ...state,
        scheduled: {
          data: [],
          loading: false,
          error: null
        }
      }

    case FILTER_BY_ROUNDS:
      return {
        ...state,
        scheduled: {
          ...state.scheduled,
          filteredData: action.payload
        }
      }

    case GET_SHORTLISTED_REQUEST:
      return {
        ...state,
        shortListed: {
          ...state.shortListed,
          loading: true,
          error: null
        }
      }

    case GET_SHORTLISTED_SUCCESS:
      return {
        ...state,
        shortListed: {
          ...state.shortListed,
          data: action.payload,
          loading: false,
          error: null
        }
      }

    case GET_SHORTLISTED_FAILURE:
      return {
        ...state,
        shortListed: {
          ...state.shortListed,
          loading: false,
          error: action.payload
        }
      }

    default:
      return state
  }
}

export default interviewReducer
